import { create } from "zustand";
import { persist } from "zustand/middleware";

interface SidebarStore {
    isCollapsed: boolean;
    toggleCollapse: () => void;
    setCollapsed: (collapsed: boolean) => void;
}

export const useSidebarStore = create<SidebarStore>()(
    persist(
        (set) => ({
            isCollapsed: false,
            toggleCollapse: () => {
                set((state) => ({ isCollapsed: !state.isCollapsed }));
            },
            setCollapsed: (collapsed) => {
                set({ isCollapsed: collapsed });
            },
        }),
        {
            name: "maeiz-tenant-sidebar",
            storage: {
                getItem: (name) => {
                    const str = localStorage.getItem(name);
                    return str ? JSON.parse(str) : null;
                },
                setItem: (name, value) => {
                    localStorage.setItem(name, JSON.stringify(value));
                },
                removeItem: (name) => {
                    localStorage.removeItem(name);
                },
            },
        }
    )
);

